module.exports = __webpack_public_path__ + "img/a-propos-prestations-2.84bb8a30.png";